<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container style="padding:24px">
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Reprogramar visita</h3>
            </v-col>
            <v-col cols="1" md="1" class="close-icon-container">
              <v-icon
                @click="$emit('close-dialog')"
                style="transform: translateX(-15px)"
                >close</v-icon
              >
            </v-col>
          </div>
          <div style="height: 60px;"></div>
          <v-row>
            <v-col cols="12">
              <v-dialog
                ref="dialog"
                v-model="datePickerDialog"
                :return-value.sync="selectedDate"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedDate"
                    label="Fecha de la nueva visita"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    locale="es-ar"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="selectedDate" scrollable locale="es-ar">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="datePickerDialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(selectedDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12">
              <v-select
                label="Horario"
                :items="timeRanges"
                v-model="selectedTimeRange"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-btn
                :disabled="!selectedDate || !selectedTimeRange"
                @click="saveVisit()"
                color="secondary"
                block
                >proponer nueva visita</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import moment from "moment";

export default {
  props: {
    show: Boolean,
    requestId: Number,
    requestAddress: String,
    visitId: Number,
    onPremises: Boolean,
    serviceId: Number
  },
  data() {
    return {
      datePickerDialog: false,
      selectedDate: null,
      now: moment().format("HH:mm"),
      timeRanges: [],
      unformattedTimeRanges: [],
      selectedTimeRange: null
    };
  },
  created() {},
  mounted() {
    this.getTimeRanges();
  },
  methods: {
    getTimeRanges() {
      this.axios
        .get(`service/${this.serviceId}/time_ranges/`)
        .then(response => {
          this.unformattedTimeRanges = response.data;
          this.timeRanges = this.unformattedTimeRanges.map(item => {
            return {
              value: item.id,
              text: item.time_from + " - " + item.time_until
            };
          });
        });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
    saveVisit() {
      const body = {
        id: 3,
        new_date: this.selectedDate,
        reason: 6,
        time_ranges: this.selectedTimeRange
      };
      if (this.onPremises) {
        body.id = 7;
      }
      this.axios
        .post(`/visit/${this.visitId}/reschedule/`, body)
        .then(response => {
          this.$store.commit(
            "show_alert",
            `Se ha propuesto una nueva visita para el dia ${this.formatDate(
              this.selectedDate
            )} a las ${this.timeRanges[this.selectedTimeRange].text}`
          );
          // this.$store.commit("reload_data", true);
          this.$emit("reload-request");
          this.$emit("close-dialog");
        })
        .catch(() => {
          this.$store.commit("show_alert", "Ha ocurrido un error");
        });
    }
  }
};
</script>

<style scoped>
@media (min-width: 960px) {
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
